<template>
    <v-dialog 
        v-if="dialog.is_show"
        v-model="dialog.is_show"
        :width="dialog.width"
        @click:outside="sendEvent('outside')"
    >

        <v-card>

            <v-card-title 
                class="text-h5 pl-2 primary white--text"
            >
                {{dialog.title}}
            </v-card-title>

            <v-card-text
                class="pl-2 pr-2 mt-3 mb-3 pb-0"
            >
                <v-form lazy-validation @submit.prevent>
                    <v-row v-for="(field, idx) in dialog.fields" :key="idx">
                        <v-col
                            cols="12"
                        >
                            <h5>{{field.name}}</h5>
                            <v-text-field
                                dense
                                outlined
                                :required="field.required"
                                v-model="field.value"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="grey"
                    text
                    @click="sendEvent(setting.cancel_event)"
                >
                    {{setting.cancel_text}}
                </v-btn>
                <v-btn
                    color="primary"
                    text
                    @click="sendEvent(setting.submit_event)"
                >
                    {{setting.submit_text}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    props: {
        setting: null,
    },  
    name: 'DialogInput',
    data () {
        return {
            dialog: null,
        }
    },
    methods: {
        sendEvent(event_name){
            this.dialog.is_show = false
            this.$emit(event_name, this.dialog)
        }
    },
    created(){
        this.dialog = JSON.parse(JSON.stringify(this.setting))
    },
    mounted(){

    }
}

</script>